import React, { useState } from "react";
import { Button, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { getBoardingManual } from "../../redux/on&offBoarning/monitor/actions";
const LinkDescargaBoarding = (props) => {
  //*states
  const [loader, setLoader] = useState(false);
  //*variables
  const dispatch = useDispatch();
  return (
    <OverlayTrigger
      placement="auto"
      overlay={<Tooltip {...props}>Descargar desglose workflow</Tooltip>}
    >
      <Button
        size="sm"
        className="text-secondary rounded"
        variant="link"
        type="button"
        onClick={() =>
          dispatch(getBoardingManual(props.id, props.nombre, setLoader))
        }
        disabled={loader}
      >
        {loader ? (
          <Spinner
            className="ml-2"
            animation="border"
            variant="primary"
            size="sm"
          />
        ) : (
          <i className="material-icons">download</i>
        )}
      </Button>
    </OverlayTrigger>
  );
};

export default LinkDescargaBoarding;
